"use client";
import * as stylex from "@stylexjs/stylex";
import { replayStyles as styles } from "../viewer/replay.styles";
import { type FrameLayout } from "./replay-frame.types";
import { frameSize } from "./replay-frame-layout";

export function ReplayFailure({
  error,
  onRetry,
  ...layout
}: FrameLayout & { error: string; onRetry: () => void }) {
  return (
    <div
      {...stylex.props(
        styles.frame,
        styles.card,
        !layout.bare && styles.bordered,
        layout.bare ? styles.page : styles.surface,
      )}
      style={frameSize(layout)}
      role="alert"
    >
      <span {...stylex.props(styles.text)}>{error}</span>
      <button type="button" onClick={onRetry} {...stylex.props(styles.action)}>
        Try again
      </button>
    </div>
  );
}
